//provider
import { useProducts } from "../../Providers/Products";

//form
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

//components & styles
import Input from "../Input";
import Button from "../Button";
import { Container } from "./styles";

//interfaces
import { IProductAPI } from "../../Interfaces";
import { userID } from "../../Services/api";

interface IProductProps {
  handleForm: (data: IProductAPI, id?: number | undefined) => void;
  buttonName: string;
  product?:
    | { currentTitle: string; currentPrice: number; id?: number | undefined }
    | undefined;
  handleModal: () => void;
}

interface IProductForm {
  title: string;
  price: string;
}

export const RegisterProductsForm = ({
  product = { currentTitle: "", currentPrice: 0, id: 0 },
  handleForm,
  buttonName,
  handleModal,
}: IProductProps) => {
  const { currentPrice, currentTitle, id } = product;
  const { getProducts } = useProducts();

  const formSchema = yup.object().shape({
    title: yup.string().required("Nome Obrigatótio"),
    price: yup
      .string()
      .required("Valor obrigatório")
      .matches(/^\d+$/, "Apenas números"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IProductForm>({
    resolver: yupResolver(formSchema),
    defaultValues: {
      title: currentTitle,
      price: currentPrice ? currentPrice.toString() : "",
    },
  });

  const onSubmit = (data: IProductForm): void => {
    const { title, price } = data;
    const priceNumber = Number(price);
    handleForm({ title: title, price: priceNumber, idAdm: userID, id: id });
    handleModal();
    getProducts();
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          className="title"
          label="Novo Produto"
          name="title"
          register={register}
          placeholder="Nome"
        />
        {!!errors.title && <p className="error">{errors.title.message}</p>}
        <Input
          className="price"
          label="Valor"
          name="price"
          register={register}
          placeholder="Preço"
        />
        {!!errors.price && <p className="error">{errors.price.message}</p>}
        <Button className="submit">{buttonName}</Button>
      </form>
    </Container>
  );
};
